import {useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {GetVesselsList} from "services/api_v2/Processes/Processes.service";
import {CustomAutocomplete} from "ui";
import {AutoCompleteData} from "ui/CustomAutoComplete/CustomAutoComplete";
import useChangeDAteAndAutocomplete from "views/ProcessDetails/hooks/useChangeDAteAndAutocomplete";
import useHandleFieldLists from "views/ProcessDetails/hooks/useHandleFieldLists";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {getTooltipText} from "views/ProcessDetails/utils/getTooltipText";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageVesselField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();
  const [vesselsOptions, setVesselsOptions] = useState(
    [] as AutoCompleteData[],
  );
  const [searchFields, setSearchFields] = useState({
    vessels: "",
  });
  const {
    getOptions: getVesselsOptions,
    onBottomScroll: onBottomScrollVessels,
    isLoadingOptions: isLoadingVesselsOptions,
  } = useHandleFieldLists(GetVesselsList);

  const {handleChangeAutocomplete, mountOptions} =
    useChangeDAteAndAutocomplete();

  return (
    <Controller
      name={`boarding.voyages.${index}.vessel` as `boarding.voyages.0.vessel`}
      control={control}
      render={({field: {value}}) => (
        <CustomAutocomplete
          fullWidth
          textFieldProps={{
            label: "Navio",
          }}
          name={`boarding.voyages.${index}.vessel`}
          placeholder="Navio"
          tooltipText={getTooltipText(value?.name)}
          loading={isLoadingVesselsOptions}
          options={mountOptions(value, vesselsOptions)}
          value={value?.name ?? ""}
          onOpen={() => getVesselsOptions(setVesselsOptions, 1, "")}
          onInputChange={(e, value) => {
            if (e !== null) {
              setSearchFields((prev) => ({
                ...prev,
                vessels: value,
              }));
              getVesselsOptions(setVesselsOptions, 1, value);
            }
          }}
          getNextPage={() => {
            onBottomScrollVessels(setVesselsOptions, searchFields.vessels);
          }}
          onChange={(e, value) => {
            handleChangeAutocomplete(
              e,
              value,
              `boarding.voyages.${index}.vessel`,
            );
          }}
          isOptionEqualToValue={(option, value) => value === option?.label}
          disabled={disabled}
        />
      )}
    />
  );
};

export default VoyageVesselField;
